import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dashboards-chart__title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopStatisticChart = _resolveComponent("TopStatisticChart")!
  const _component_IndicatorCard = _resolveComponent("IndicatorCard")!

  return (!_ctx.hideWhenEmpty || _ctx.isLoading || _ctx.items.length)
    ? (_openBlock(), _createBlock(_component_IndicatorCard, {
        key: 0,
        mod: "inverted-card",
        class: _normalizeClass(["dashboards-chart", { 'dashboards-chart_loading': _ctx.isLoading }])
      }, {
        values: _withCtx(() => [
          _createVNode(_component_TopStatisticChart, {
            items: _ctx.items,
            year: _ctx.filter.year,
            isLoading: _ctx.isLoading,
            isBarClickable: _ctx.isBarClickable,
            onBarClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('barClick', $event)))
          }, {
            title: _withCtx(() => [
              (_ctx.title)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true),
              (_ctx.$slots.title)
                ? _renderSlot(_ctx.$slots, "title", { key: 1 }, undefined, true)
                : _createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["items", "year", "isLoading", "isBarClickable"])
        ]),
        _: 3
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}